<template>
    <v-card class="hotel-info-room-offers" variant="outlined" data-cy="hotel-room-offers">
        <hotel-info-room-offers-header :filtered-offer :is-search-active :loaded @set-filters="setFilters" />
        <hotel-room-offers
            v-if="loaded"
            v-model="selectedOfferKeys"
            :offer="filteredOffer"
            :search-request="searchRequest"
        >
            <template v-slot:price="{room}">
                <slot name="price" :room="room" />
            </template>
        </hotel-room-offers>
        <template v-if="isSearchActive && !filteredOffer">
            <v-card-title v-if="!filteredOffer" class="text-h6 font-weight-light">
                {{ $t('loading_room_offers') }}...
            </v-card-title>
            <v-skeleton-loader transition="fade-transition" height="100" type="list-item-three-line" />
        </template>
        <v-card-actions v-if="searchRoomsCount > 1 && filteredOffer" class="flex-column">
            <hotel-multiple-room-select-block
                :search-request="searchRequest"
                :selected-offer-keys="selectedOfferKeys"
                :offer="filteredOffer"
            />
        </v-card-actions>
        <conditions-modal>
            <template v-slot:info>
                <hotel-conditions-modal-info />
            </template>
            <template v-slot:hotelPriceNote>
                <hotel-price-note :search-request="searchRequest" />
            </template>
        </conditions-modal>
        <hotel-room-info-modal />
        <hotel-meal-type-info-modal />
        <additional-fees-modal />
    </v-card>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import ConditionsModal from '~/components/modals/ConditionsModal.vue'
    import HotelRoomOffers from '~/components/search/offers/HotelRoomOffers.vue'
    import HotelRoomInfoModal from '~/components/modals/HotelRoomInfoModal.vue'
    import HotelPriceNote from '@/components/hotels/snippets/HotelPriceNote.vue'
    import HotelMealTypeInfoModal from '@/components/hotels/modals/HotelMealTypeInfoModal.vue'
    import HotelConditionsModalInfo from '@/components/hotels/snippets/HotelConditionsModalInfo.vue'
    import HotelMultipleRoomSelectBlock from '~src/components/hotels/snippets/hotelMultipleRoomSelectBlock.src'
    import AdditionalFeesModal from '~src/components/modals/AdditionalFeesModal.vue'
    import SortSelect from '@/components/search/SortSelect.vue'
    import hotelsFilter from '@/filters/hotelsFilter'
    import HotelInfoRoomOffersHeader from '~src/components/hotels/info/snippets/HotelInfoRoomOffersHeader.vue'

    @Component({
        components: {
            AdditionalFeesModal,
            HotelMultipleRoomSelectBlock,
            HotelConditionsModalInfo,
            HotelMealTypeInfoModal,
            HotelPriceNote,
            ConditionsModal,
            HotelRoomOffers,
            HotelRoomInfoModal,
            SortSelect,
            HotelInfoRoomOffersHeader,
        },
    })
    export class HotelInfoRoomOffersWrapper extends Vue {
        @Prop({required: true}) searchRequest
        @Prop({required: true}) offer

        selectedOfferKeys = []
        loaded = false
        filters = {
            mealTypes: [],
            roomTypes: [],
            availability: [],
        }

        async mounted() {
            await this.$store.restored
            if (this.filteredOffer) {
                await this.onfilteredOfferChange(this.filteredOffer)
            }
        }

        setFilters(val) {
            this.filters.mealTypes = val.mealTypes ? val.mealTypes : []
            this.filters.roomTypes = val.roomTypes ? val.roomTypes : []
            this.filters.availability = val.availability ? val.availability : []
        }

        @Watch('filteredOffer')
        async onfilteredOfferChange(filteredOffer) {
            if (!filteredOffer) return
            try {
                await hotelsRuntimeStore.loadHotelsInfoByOffer(filteredOffer)
            } catch {
                this.$toast.error(this.$t('load_hotels_info_messages_error'))
            } finally {
                this.loaded = true
            }
        }

        get filteredOffer() {
            return this.offer ? hotelsFilter([this.offer], this.filters)[0] : null
        }

        get isSearchActive() {
            return hotelsRuntimeStore.singleHotelSearchActive
        }

        get searchRoomsCount() {
            return this.searchRequest.rooms?.length || 1
        }

        get productStore() {
            return hotelsStore
        }
    }

    export default HotelInfoRoomOffersWrapper
</script>
